// extracted by mini-css-extract-plugin
module.exports = {"dropZoneContent":"AppFileDropzone_dropZoneContent__2Ont3","dragAccepted":"AppFileDropzone_dragAccepted__15V_z","dragRejected":"AppFileDropzone_dragRejected__3lP2B"};